module.exports = __webpack_public_path__ + "static/media/empty.8875eda9.png";